// src/config.js

const ENV = process.env.REACT_APP_ENV || 'development';

const config = {
  development: {
    API_BASE_URL: 'https://rsaapi.gaadibazaar.net/api/',
    LOGIN_API_BASE_URL: 'https://loginapi.gaadibazaar.net/',
    PRELOGIN_TANDC_URL : 'https://gaadibazaar.net/user-agreement',
  },
  staging: {
    API_BASE_URL: 'https://rsaapi.gaadibazaar.net/api/',
    LOGIN_API_BASE_URL: 'https://api.gaadibazaar.co.in/gaadibazaar_login/',
    PRELOGIN_TANDC_URL : 'https://gaadibazaar.co.in/user-agreement',
  },
  preprod: {
    API_BASE_URL: 'http://127.0.0.1:8000/api',
    LOGIN_API_BASE_URL: 'https://loginapi.gaadibazaar.net/',
    PRELOGIN_TANDC_URL : 'https://gaadibazaar.net/user-agreement',
  },
  production: {
    API_BASE_URL: 'https://rsaapi.gaadibazaar.net/api/',
    LOGIN_API_BASE_URL: 'https://api.gaadibazaar.co.in/gaadibazaar_login/',
    PRELOGIN_TANDC_URL : 'https://gaadibazaar.in/user-agreement',
  },
};

export default config[ENV];
